import { useSession } from '@airship-platform/airship-auth';
import { FlexBox } from '@airship-platform/jam-web/components';
import { CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';

const removeStorageKeys = (storage: Storage) => {
  const keysToRemove = ['airship:offline', 'airship-cache'] as const;
  const excludedKeys = ['offline-data-opted-in'] as const;
  const foundKeys = new Set<string>();

  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (
      key &&
      keysToRemove.some((k) => key.startsWith(k)) &&
      !excludedKeys.some((k) => key.endsWith(k))
    ) {
      foundKeys.add(key);
    }
  }

  for (const key of foundKeys) {
    storage.removeItem(key);
  }
};

const SignOutPage: React.FC = () => {
  const { signOut } = useSession();

  useEffect(() => {
    try {
      removeStorageKeys(localStorage);
      removeStorageKeys(sessionStorage);
    } finally {
      signOut();
    }

    const timeoutId = setTimeout(() => {
      window.location.replace('/');
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [signOut]);

  return (
    <FlexBox
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      alignSelf={'center'}
      height={'100vh'}
      gap={4}
    >
      <Typography variant="h4">Signing you out...</Typography>
      <CircularProgress color="primary" />
    </FlexBox>
  );
};

export default SignOutPage;
